/* Satya Heritage — product tabs and the sticky add-to-cart bar. */
(function () {
  "use strict";
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* product tabs */
  $$("[data-tabs]").forEach(function (root) {
    var tabs = $$("[role=tab]", root);
    function show(t) {
      tabs.forEach(function (x) {
        var on = x === t, panel = document.getElementById(x.getAttribute("aria-controls"));
        x.setAttribute("aria-selected", on ? "true" : "false"); x.tabIndex = on ? 0 : -1;
        if (panel) { panel.hidden = !on; if (on) { panel.classList.remove("ptabs__panel--in"); void panel.offsetWidth; panel.classList.add("ptabs__panel--in"); } }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { show(t); });
      t.addEventListener("keydown", function (e) {
        var k = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0; if (!k) return;
        var n = tabs[(i + k + tabs.length) % tabs.length]; n.focus(); show(n);
      });
    });
  });

})();
